<template slot="bills" slot-scope="props">
  <tr
    style="cursor: pointer"
    :class="{ 'blue lighten-5': updated, 'green lighten-5': created, 'red lighten-5': credit, 'grey lighten-3': closed}"
    @click="editBill()"
  >
    <td @click.stop>
      <v-checkbox v-model="selected" :color="$store.state.global.pages.billing.color" hide-details></v-checkbox>
    </td>

    <td v-for="(header,i) in headers" :key="i" :class="`text-xs-${header.align}`">
      <span v-if="header.type == 'count'">{{ getObjectPath(header.value, bill).length || "-" }}</span>
      <span v-if="header.type == 'date'">{{ makeShortDate(getObjectPath(header.value, bill)) || "-" }}</span>
      <span v-if="header.type == 'time'">{{ makeTime(getObjectPath(header.value, bill)) || "-" }}</span>
      <span v-if="header.type == 'num'">{{ displayDecimal(getObjectPath(header.value, bill),header.decimals) || "-" }}</span>
      <span v-if="header.type == 'curr'">
        {{ !!getObjectPath(header.value, bill) ? `$${displayDecimal(getObjectPath(header.value, bill),header.decimals)}` : "-" || "" }}
      </span>
      <v-tooltip top max-width="350" v-if="header.type == 'tooltip'" :disabled="!getObjectPath(header.value, bill)">
        <span slot="activator">{{ truncatedField(getObjectPath(header.value, bill) || "-") }}</span>
        {{ getObjectPath(header.value, bill)}}
      </v-tooltip>
      <span v-if="header.type == 'text'">{{ getObjectPath(header.value, bill) || "-" }}</span>

      <!--ACTIONS COLUMN -->
      <div
        v-if="header.type == 'action' && userAuthClass"
        class="justify-center layout px-0"
        @click.stop
      >
        <!-- TRIP OPTIONS MENU -->
        <v-menu bottom left>
          <v-btn icon flat color="grey" slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <!-- <basic-list-tile title="Edit" icon="edit" :onClick="editBill"></basic-list-tile>
            <v-divider inset></v-divider> -->
            <basic-list-tile
              :disabled="!!bill.billLineId"
              color="red lighten-3"
              title="Delete"
              icon="delete"
              :onClick="deleteBill"
            ></basic-list-tile>
          </v-list>
        </v-menu>
      </div>
      <!--END ACTIONS COLUMN -->
    </td>
    <!-- END CELLS -->

    <!--  DIALOGS  -->
    <!-- Bill edit dialog -->
    <!-- <v-dialog lazy v-model="editDialog" max-width="700px" @keydown.esc="editDialog = false">
      <edit-approved-bill-line @close="editDialog = false" :approvedBillLine="bill"></edit-approved-bill-line>
    </v-dialog> -->
    <!--DELETE PROMPT DIALOG -->
    <v-dialog lazy v-model="deleteDialog" max-width="700px" @keydown.esc="deleteDialog = false">
      <delete-approved-bill-line @close="deleteDialog = false" :id="bill.id"></delete-approved-bill-line>
    </v-dialog>
  </tr>
</template>

<script>
import DeleteApprovedBillLine from '@/modules/approvedBillLines/deleteApprovedBillLine'
import FormatDates from '@/services/mixins/formatDates'

import CreatedUpdatedRows from '@/services/mixins/createdUpdatedRows'
import RowDisplayMethods from '@/services/mixins/rowDisplayMethods'
export default {
  mixins: [FormatDates, CreatedUpdatedRows, RowDisplayMethods],
  components: {
    DeleteApprovedBillLine
  },
  props: {
    bill: Object,
    headers: Array,
    value: Boolean
  },
  data() {
    return {
      prefix: 'bill',
      editDialog: false,
      deleteDialog: false,
      actionConfirmationDialog: false,
      summaryDialog: false,
      actionsMenu: false,
      currentNotes: '',
      fieldData: {}
    }
  },
  methods: {
    actionComplete() {
      this.fieldData = {}
      this.actionConfirmationDialog = false
    },
    deleteBill() {
      this.deleteDialog = true
    },
    editBill() {
      this.editDialog = true
    },
    viewSummaryDialog() {
      this.summaryDialog = true
    },
    confirmUpdateBillField(payload) {
      this.fieldData = payload
      this.currentNotes = this.bill[payload.notesField]
      this.actionConfirmationDialog = true
    },
    truncatedField(text) {
      const string = text.length > 20 ? `${text.slice(0, 20)}...` : text
      return string
    }
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', { value: val, object: this.bill })
      }
    },
    credit() {
      return this.bill.type == 'CREDIT'
    },
    closed() {
      return !!this.bill.billLineId
    }
  }
}
</script>

<style>
.v-input--selection-controls .v-input__slot {
  margin-bottom: 3px;
}
</style>
